
import Services from './base-services'

const service = new Services('departments')

export default {
  listFromSuite: () => {
    return service.suiteOperation(() => service.get('list'))
  }
}
